import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { Meta } from '../../angular2-meta';

@Component({
  selector: 'nns-image-attachment',
  template: `
    <div flex="none">
      <nns-image
      [attachment]="attachment"
      ></nns-image>
    </div>
  `,
  styles: [`
  `, `
    :host-context(.nns-theme-night) {
      background:#2f3737;
    }
  `]
})
export class ImageAttachmentComponent implements OnInit, OnChanges {
  @Input() attachment;
  @Input() share;
  @Input() note;

  constructor(
    public _meta: Meta
  ) { }

  ngOnInit() {
    this.setMeta();
  }

  ngOnChanges() {
    this.setMeta();
  }

  setMeta() {
    this._meta.setMetaForAttachment(this.share, this.note, this.attachment);
  }
}
